<div class="archive-filters">
  <mat-form-field class="archive-filters__search">
    @if (searchCtrl.value) {
      <mat-icon matIconSuffix (click)="searchCtrl.setValue('')">close</mat-icon>
    }
    <input matInput placeholder="Search in the table" [formControl]="searchCtrl" />
  </mat-form-field>
  <mat-icon class="material-icons-outlined archive-filters__info" [matTooltip]="tooltipMessage">info</mat-icon>
</div>
